/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Requireauth_Reviews_Title1Inputs */

const he_auth_requireauth_reviews_title1 = /** @type {(inputs: Auth_Requireauth_Reviews_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברו כדי לכתוב ביקורת`)
};

const en_auth_requireauth_reviews_title1 = /** @type {(inputs: Auth_Requireauth_Reviews_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to write a review`)
};

/**
* | output |
* | --- |
* | "Sign in to write a review" |
*
* @param {Auth_Requireauth_Reviews_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_requireauth_reviews_title1 = /** @type {((inputs?: Auth_Requireauth_Reviews_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Requireauth_Reviews_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_requireauth_reviews_title1(inputs)
	return en_auth_requireauth_reviews_title1(inputs)
});
export { auth_requireauth_reviews_title1 as "auth_requireAuth_reviews_title" }